import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";

import products from "./modules/products.js";
import certificates from "./modules/certificates.js";
import pricelist from "./modules/pricelist.js";

Vue.use(Vuex);

const errorHandler = (error, url) => {
  if (error.response) {
    // The request was made and the server responded with a status code
    // that falls out of the range of 2xx
    //console.log(error.response.data);
    //console.log(error.response.status);
    //console.log(error.response.headers);
    throw new Error(
      `${url} - ${error.response.status} ${error.response.statusText} ${
        error.response.data.status_code
      } ${error.response.data.status_message}`
    );
  } else if (error.request) {
    // The request was made but no response was received
    // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
    // http.ClientRequest in node.js
    //console.log(error.request);
    throw new Error(`${url} - ${error.message}`);
  } else {
    // Something happened in setting up the request that triggered an Error
    throw new Error(`${url} - ${error.message}`);
  }
};

export default new Vuex.Store({
  state: {
    formProcessed: false,
    formSubmitted: false,
    formError: "",
    formData: [
      {
        name: "name",
        placeholder: "Имя",
        type: "text",
        value: "",
        pattern: /^[a-zA-Zа-яА-ЯёЁ\d ]{1,30}$/,
        status: false,
      },
      {
        name: "phone",
        placeholder: "Телефон",
        type: "tel",
        value: "",
        pattern: /^[+0-9]{5,14}$/,
        status: false,
      },
    ],
  },
  getters: {
    formProcessed(state) {
      return state.formProcessed;
    },
    formSubmitted(state) {
      return state.formSubmitted;
    },
    formError(state) {
      return state.formError;
    },
    formData(state) {
      return state.formData;
    },
    validCnt(state) {
      let done = 0;

      for (let i = 0; i < state.formData.length; i++) {
        if (state.formData[i].status) {
          done++;
        }
      }

      return done;
    },
  },
  mutations: {
    setFormProcessed(state, payload) {
      state.formProcessed = payload;
    },
    setFormSubmitted(state, payload) {
      state.formSubmitted = payload;
    },
    setFormError(state, payload) {
      state.formError = payload;
    },
    updateValue(state, data) {
      state.formData[data.index].value = data.value;
    },
    updateStatus(state, data) {
      state.formData[data.index].status = data.status;
    },
  },
  actions: {
    sendLetter(store, payload) {
      store.commit("setFormProcessed", true);
      store.commit("setFormError", "");
      console.log(JSON.stringify(payload));

      const url = "https://api.sk-grant.kz/api/v1/post-form";

      return axios
        .post(url, payload)
        .then(({ data }) => {
          console.log("response " + JSON.stringify(data));
          if (data.message === "success") {
            store.commit("setFormSubmitted", true);
            store.commit("setFormProcessed", false);
          } else {
            throw new Error("Ошибка при отправке данных");
          }
        })
        .catch(error => {
          errorHandler(error, url);
        })
        .catch(error => {
          console.log(error.message);
          store.commit("setFormError", "Ошибка при отправке");
          store.commit("setFormProcessed", false);
        });
    },
    updateValue(store, data) {
      store.commit("updateValue", data);
    },
    updateStatus(store, data) {
      store.commit("updateStatus", data);
    },
    resetForm(store) {
      store.commit("setFormSubmitted", false);
    },
  },
  modules: {
    products,
    certificates,
    pricelist,
  },
  strict: process.env.NODE_ENV !== "production",
});
